import { defaultRegistry } from 'react-sweet-state';

import { Store } from './store';

export const triggerFileUploadDialog = (): void => {
	defaultRegistry.getStore(Store)?.actions.openFileDialog();
};
